import { humanize } from "../lib/format";
import type { UsageValue } from "../lib/types";
import { usdShort } from "./insights/util";
import {
  API_SAVED_TIP,
  KEPT_OFF_TIP,
  STRETCH_TIP,
  plansPhrase,
  shownFamilies,
  stretchLabel,
} from "./insights/value";

export type ValueTile = {
  label: string;
  info: string;
  value: string;
  note: string;
};

/** The subscriber's own measured value over the last 30 days, or null when
 * nothing has been measured yet. Wording matches My usage. */
export function valueTile(v: UsageValue | null | undefined): ValueTile | null {
  const sub = v?.subscription;
  if (sub && v) {
    const plan = plansPhrase(shownFamilies(v));
    const more = stretchLabel(sub.stretch);
    if (more)
      return {
        label: "More work per window",
        info: STRETCH_TIP,
        value: more,
        note: `On your ${plan}, last 30 days · ${humanize(sub.tokens_kept_off)} tokens kept off`,
      };
    if (sub.tokens_kept_off > 0)
      return {
        label: "Tokens kept off",
        info: KEPT_OFF_TIP,
        value: humanize(sub.tokens_kept_off),
        note: `Never counted against your ${plan}, last 30 days`,
      };
  }
  const api = v?.api;
  if (api && Number(api.saved_usd) > 0)
    return {
      label: "Money saved",
      info: API_SAVED_TIP,
      value: usdShort(api.saved_usd),
      note: "On your API bill, last 30 days",
    };
  return null;
}
